import {
  PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getSortedRowModel, SortingState, useReactTable,
} from "@tanstack/react-table";
import DivLoader from "components/divloader/DivLoader";
import React, { useEffect, useState } from "react";
import Pagination from "components/pagination";
import { BsArrowDown, BsArrowUp } from "react-icons/bs";
import { RiArrowUpDownFill } from "react-icons/ri";
import { PayoutRowObj } from "..";
import moment from "moment";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import ShortTruncateCopy2 from "components/common/RegistrationLinkCopy";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import Searchbox from "components/fields/Searchbox";
import StatusRender from "views/admin/payments/components/StatusRender";
import { getImage } from "utils/commonFunction";
import AddBatchFile from "./AddBatchFile";
import FilterModal from "./FilterModal";
import { getAllClients } from "api/clients";
import toast from "react-hot-toast";

const columnHelper = createColumnHelper<PayoutRowObj>();

function PayinList(props: {
  tableData: any; fetchPayouts: () => void; fetchPayoutsForBatch: () => void;
  onValueChange: (value: string) => void; roleData?: any; isLoading: boolean;
  page: number; setPage: any; totalpage: number; totalItems: number;
  currentPage: number; pageSize: number; setPageSize: any; filterData: () => void;
  filter: any; setFilter: (e: any) => void;
  setLocalFilters?: (e: any) => void; setClearClick: () => void; localFilters?: any;allOrgDetails:any
}) {
  const { tableData, onValueChange, isLoading, roleData, page, setPage,totalItems,filter,filterData,setFilter,setClearClick,
    totalpage, currentPage, pageSize, setPageSize, fetchPayoutsForBatch,allOrgDetails } = props;

  const [{ pageIndex }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize });
  const [expandedRow, setExpandedRow] = useState<string | null>(null);
  const [sorting, setSorting] = React.useState<SortingState>([]);
  const [data, setData] = React.useState(() => [...(tableData ?? [])]);
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);

  const [subClientsData, setSubClientsData] = useState([]);

  React.useEffect(() => { setExpandedRow(null); }, [page, pageSize]);
  useEffect(() => { setData(tableData?.map((item: any) => ({ ...item })) ?? []); }, [tableData]);

  const handleExpand = (rowId: any) => setExpandedRow(expandedRow === rowId ? null : rowId);

  const columns = [
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: () => <span className="cpl-th">Created Date</span>,
      cell: (info: any) => (
        <button className="cpl-expand-cell" onClick={() => handleExpand(info?.row?.original?.id)}>
          {expandedRow === info?.row?.original?.id
            ? <AiFillMinusCircle className="cpl-expand-icon cpl-expand-icon--minus" />
            : <AiFillPlusCircle className="cpl-expand-icon cpl-expand-icon--plus" />}
          <span className="cpl-date">{moment(info.getValue()).format("YYYY-MM-DD HH:mm:ss")}</span>
        </button>
      ),
    }),
    columnHelper.accessor("batchId", {
      id: "batchId",
      header: () => <span className="cpl-th">Batch ID</span>,
      cell: (info) => <ShortTruncateCopy info={info?.getValue()} showCopy />,
    }),
    columnHelper.accessor("clientName", {
      id: "clientName",
      header: () => <span className="cpl-th">Client</span>,
      cell: (info) => (
        <div className="cpl-client-cell">
          <div className="cpl-client-avatar">{info.getValue()?.charAt(0)?.toUpperCase() || "?"}</div>
          <span className="cpl-client-name">{info.getValue()}</span>
        </div>
      ),
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.clientName || "";
        const b = rowB.original.clientName || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.batchId).localeCompare(String(rowB.original.batchId));
      },
    }),
    columnHelper.accessor("totalTransactions", {
      id: "totalTransactions",
      header: () => <span className="cpl-th">TX #</span>,
      cell: (info: any) => <span className="cpl-num">{info.getValue()}</span>,
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.totalTransactions || "";
        const b = rowB.original.totalTransactions || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.batchId).localeCompare(String(rowB.original.batchId));
      },
    }),
    columnHelper.accessor("gatewayName", {
      id: "gatewayName",
      header: () => <span className="cpl-th">Gateway {roleData?.[0]?.crypto?.value?.show_crypto_payout_gateway_name ? "Name" : "Hash ID"}</span>,
      cell: (info: any) => (
        !roleData?.[0]?.crypto?.value?.show_crypto_payout_gateway_name
          ? <ShortTruncateCopy info={info?.row?.original?.gatewayId || "—"} showCopy />
          : <div className="cpl-gateway-cell">
              <img style={{ height:"auto", width:"14px" }} src={getImage(info.getValue())} alt="" />
              <span className="cpl-gateway-name">{info.getValue() || "—"}</span>
            </div>
      ),
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.gatewayName || "";
        const b = rowB.original.gatewayName || "";
        const result = a.localeCompare(b);
        if (result !== 0) {
          return result;
        }
        return String(rowA.original.batchId).localeCompare(String(rowB.original.batchId));
      },
    }),
  ];

  const resetRow = () => {
    setExpandedRow(null);
  }

  const table = useReactTable({
    data,
    columns,
    state: { pagination, sorting },
    onPaginationChange: setPagination, onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(), getSortedRowModel: getSortedRowModel(),
  });

  const SUB_HEADERS = ["Created At","Customer ID","Quote ID","Invoice Amount","Payment Amount","Checkout Link","Status"];

  const getSubClientsData = () => {
      getAllClients(0)
      .then((data) => setSubClientsData(data[0]))
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while fetching clients"))
      .finally(() => {  });
  };
  
  React.useEffect(() => { getSubClientsData(); }, []);
  
  return (
    <div className="cpl-card">
      {/* Header */}
      <div className="cpl-header">
        <div className="cpl-header-left">
          <div className="cpl-header-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
              <polyline points="17 6 23 6 23 12"/>
            </svg>
          </div>
          <div>
            <h3 className="cpl-title">Crypto Payin</h3>
            {/* <p className="cpl-subtitle">Incoming crypto batch payin records</p> */}
            <p className="cpl-subtitle">{totalItems > 0 ? `${totalItems.toLocaleString()} total batch${totalItems !== 1 ? "es" : ""}` : "No batches"}</p>

          </div> 
        </div>
        <div className="cpl-header-right">
          <FilterModal
            subClientsData={subClientsData} setPage={props.setPage}
            filter={filter} setFilter={setFilter} roleData={roleData}
            setClearClick={setClearClick} 
            fetchAllsettlement={fetchPayoutsForBatch}
            allOrgDetails={allOrgDetails}
            filterData={filterData}
            resetRow= {resetRow}
          />
          <AddBatchFile fetchPayouts={fetchPayoutsForBatch} />
          <Searchbox onSearch={(e) => { setExpandedRow(null); onValueChange(e); }} />
        </div>
      </div>

      {/* Table */}
      <div className="cpl-table-wrap">
        {isLoading ? (
          <div className="cpl-loading"><div className="cpl-spinner" /><p className="cpl-loading-txt">Loading payins…</p></div>
        ) : (
          <table className="cpl-table">
            <thead>
              {table.getHeaderGroups().map((hg) => (
                <tr key={hg.id}>
                  {hg.headers.map((h) => (
                    <th key={h.id} colSpan={h.colSpan}
                      onClick={h.column.getCanSort() ? h.column.getToggleSortingHandler() : undefined}
                      className={`cpl-thead-th${h.column.getCanSort() ? " cpl-thead-th--sort" : ""}`}
                    >
                      <div className="cpl-th-inner">
                        {flexRender(h.column.columnDef.header, h.getContext())}
                        {h.column.getCanSort() && (
                          <span className="cpl-sort-icon">
                            {h.column.getIsSorted() === "asc" ? <BsArrowUp size={11} /> :
                             h.column.getIsSorted() === "desc" ? <BsArrowDown size={11} /> :
                             <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row, ri) => (
                  <React.Fragment key={row.id}>
                    <tr className={`cpl-tbody-tr${ri % 2 !== 0 ? " cpl-tbody-tr--alt" : ""}`}>
                      {row.getVisibleCells().map((cell, ci) => (
                        <td key={ci} className="cpl-tbody-td">{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                      ))}
                    </tr>

                    {expandedRow === (row.original as any).id && (
                      <tr>
                        <td colSpan={columns.length} className="cpl-expanded-cell">
                          <div className="cpl-subtable-wrap">
                            <h4 className="cpl-subtable-heading">Transactions</h4>
                            {Object.keys((row.original as any).transactions ?? {}).length > 0 ? (
                              <table className="cpl-table">
                                <thead>
                                  <tr>
                                    {SUB_HEADERS.map((h) => (
                                      <th key={h} className="cpl-thead-th"><span className="cpl-th">{h}</span></th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {Object.entries((row.original as any).transactions).map(([txId, tx]: [string, any]) => (
                                    <tr key={txId} className="cpl-tbody-tr">
                                      <td className="cpl-tbody-td"><span className="cpl-date">{moment(tx.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span></td>
                                      <td className="cpl-tbody-td"><ShortTruncateCopy info={tx.customerId} showCopy /></td>
                                      <td className="cpl-tbody-td">
                                        {tx.quoteId ? <ShortTruncateCopy info={tx.quoteId} showCopy /> : <span className="cpl-muted">—</span>}
                                      </td>
                                      <td className="cpl-tbody-td">
                                        <span className="cpl-amount">{Number(tx.invoiceAmount ?? 0).toFixed(2)} {tx.invoiceCurrency}</span>
                                      </td>
                                      <td className="cpl-tbody-td">
                                        <span className="cpl-amount">
                                          {tx.paymentAmount && !isNaN(Number(tx.paymentAmount))
                                            ? `${Number(tx.paymentAmount).toFixed(5)} ${tx.paymentCurrency}`
                                            : <span className="cpl-muted">— {tx.paymentCurrency}</span>}
                                        </span>
                                      </td>
                                      <td className="cpl-tbody-td">
                                        {tx.checkoutLink
                                          ? <ShortTruncateCopy2 info={tx.checkoutLink} showCopy slice={15} />
                                          : <span className="cpl-muted">—</span>}
                                      </td>
                                      <td className="cpl-tbody-td">
                                        <StatusRender status={tx.status} value={tx.status} />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="cpl-subtable-empty">No transactions available.</div>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr><td colSpan={6}>
                  <div className="cpl-empty">
                    <div className="cpl-empty-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                        <polyline points="17 6 23 6 23 12"/>
                      </svg>
                    </div>
                    <p className="cpl-empty-title">No payins found</p>
                    <p className="cpl-empty-sub">Upload a batch file to get started</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="cpl-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .cpl-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,.06); }

        .cpl-header { padding:15px 20px 12px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
        .cpl-header-left { display:flex; align-items:center; gap:10px; }
        .cpl-header-icon { width:36px; height:36px; border-radius:10px; background:linear-gradient(135deg,#faf5ff,#ede9fe); border:1.5px solid #ddd6fe; display:flex; align-items:center; justify-content:center; color:#7c3aed; flex-shrink:0; }
        .cpl-title { font-size:14px; font-weight:700; color:#0f172a; letter-spacing:-.2px; margin-bottom:1px; line-height:20px; }
        .cpl-subtitle { font-size:11.5px; color:#94a3b8; font-weight:500; }
        .cpl-header-right { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

        .cpl-table-wrap { overflow-x:auto; }
        .cpl-table-wrap::-webkit-scrollbar { height:3px; }
        .cpl-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .cpl-table { width:100%; border-collapse:collapse; }

        .cpl-thead-th { padding:9px 12px 8px; background:#f8fafc; border-bottom:1.5px solid #e2e8f0; text-align:left; white-space:nowrap; user-select:none; }
        .cpl-thead-th--sort { cursor:pointer; }
        .cpl-thead-th--sort:hover { background:#f1f5f9; }
        .cpl-th-inner { display:flex; align-items:center; gap:4px; }
        .cpl-th { font-size:10.5px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:.4px; }
        .cpl-sort-icon { color:#b0bec5; display:flex; align-items:center; flex-shrink:0; }

        .cpl-tbody-tr { transition:background .1s; }
        .cpl-tbody-tr:hover { background:#faf5ff; }
        .cpl-tbody-tr--alt { background:#fafbfc; }
        .cpl-tbody-tr--alt:hover { background:#f3f0ff; }
        .cpl-tbody-td { padding:8px 12px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }

        /* Expand */
        .cpl-expand-cell { display:inline-flex; align-items:center; gap:7px; background:none; border:none; cursor:pointer; padding:0; font-family:'Plus Jakarta Sans',sans-serif; }
        .cpl-expand-icon { width:18px; height:18px; flex-shrink:0; }
        .cpl-expand-icon--plus  { color:#7c3aed; }
        .cpl-expand-icon--minus { color:#dc2626; }

        /* Cell helpers */
        .cpl-client-cell { display:flex; align-items:center; gap:6px; }
        .cpl-client-avatar { width:24px; height:24px; border-radius:6px; background:linear-gradient(135deg,#faf5ff,#ede9fe); border:1.5px solid #ddd6fe; display:flex; align-items:center; justify-content:center; font-size:9.5px; font-weight:800; color:#7c3aed; flex-shrink:0; }
        .cpl-client-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
        .cpl-date { font-size:11.5px; font-weight:500; color:#334155; white-space:nowrap; }
        .cpl-num { font-size:12.5px; font-weight:700; color:#0f172a; }
        .cpl-amount { font-size:12px; font-weight:700; color:#0f172a; white-space:nowrap; }
        .cpl-gateway-cell { display:flex; align-items:center; gap:6px; }
        .cpl-gateway-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
        .cpl-muted { font-size:12px; color:#cbd5e1; }

        /* Expanded sub-table */
        .cpl-expanded-cell { padding:0 !important; border-bottom:2px solid #e2e8f0; }
        .cpl-subtable-wrap { background:#f5f0ff; border-left:3px solid #ddd6fe; padding:14px 16px; overflow-x:auto; }
        .cpl-subtable-heading { font-size:12px; font-weight:700; color:#3b0764; text-transform:uppercase; letter-spacing:.5px; margin-bottom:12px; }
        .cpl-subtable-empty { font-size:13px; color:#64748b; font-weight:500; text-align:center; padding:20px; }

        /* States */
        .cpl-loading { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px; gap:12px; }
        .cpl-spinner { width:26px; height:26px; border:3px solid #e2e8f0; border-top-color:#7c3aed; border-radius:50%; animation:cplSpin .7s linear infinite; }
        @keyframes cplSpin { to{transform:rotate(360deg)} }
        .cpl-loading-txt { font-size:12.5px; color:#94a3b8; font-weight:500; }
        .cpl-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
        .cpl-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
        .cpl-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
        .cpl-empty-sub { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }
        .cpl-pagination-wrap { padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafbfc; }

        @media (max-width:700px) { .cpl-header { flex-direction:column; align-items:flex-start; } .cpl-header-right { width:100%; } }
      `}</style>
    </div>
  );
}

export default PayinList;